const environment = process.env.REACT_APP_ENVIRONMENT || null;
const ApiHost = environment === 'production' ? 'https://api.driverhq.co.uk/' : 'http://localhost:7012';

export default ApiHost;